export type TypeRoleTypeObj = 'All' | 'Admin' | 'Division' | 'District' | 'Store';

export enum RoleTypeEnum {
  "All" = "All", "Admin" = "Admin", "Division" = "Division", "District" = "District", "Store" = "Store"
}
